export class Organigramme {
  id: number;
  institution: string;
  details: string;
  parent: Organigramme;
  couleur: string;
}
